import { STORAGE_MODE_ENABLED_KEY } from '../config/storage-keys';

export function isKeyModeEnabled(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return localStorage.getItem(STORAGE_MODE_ENABLED_KEY) === 'true';
}

// PostProcessor for key mode
export const i18nKeyModePostProcessor = {
  name: 'keyMode',
  type: 'postProcessor' as const,
  process(value: any, key: string, _options: any) {
    // Only apply key mode if it's enabled
    if (!isKeyModeEnabled()) {
      return value;
    }

    // If we have an object (from returnObjects), process it recursively
    if (typeof value === 'object' && value !== null) {
      return processObjectForKeyMode(value, key);
    }

    // For final string values, return the key instead
    if (typeof value === 'string') {
      // Handle case where key might be an array
      return Array.isArray(key) ? key.join('.') : key;
    }

    return value;
  },
};

function processObjectForKeyMode(obj: any, baseKey: string | string[]): any {
  // Normalize baseKey to string
  const normalizedBaseKey = Array.isArray(baseKey) ? baseKey.join('.') : baseKey;

  // If it's an array, process each element
  if (Array.isArray(obj)) {
    return obj.map((item, index) => processObjectForKeyMode(item, `${normalizedBaseKey}.${index}`));
  }

  // If it's not an object (final value), return the key
  if (typeof obj !== 'object' || obj === null) {
    return normalizedBaseKey;
  }

  // For objects, recursively process each property
  const result = {};

  for (const [prop, value] of Object.entries(obj)) {
    const fullKey = normalizedBaseKey ? `${normalizedBaseKey}.${prop}` : prop;

    if (typeof value === 'object' && value !== null) {
      // If it's still an object, recurse
      result[prop] = processObjectForKeyMode(value, fullKey);
    } else {
      // If it's a final value, return the full key
      result[prop] = fullKey;
    }
  }

  return result;
}
